const required = (value, row, object) => {
  if (value || typeof value === "number") {
    return false;
  } else {
    return "is required";
  }
};

export default required;
